module.exports = require("wix-seo-frontend");